<template>
    <div class="report-filter-tool" :class="{ 'report-filter-tool--datetime-open': datetimeOpen }">
        <div class="date-filter">
            <SupsisButton @click="prevDate" ghost small><i class="material-icons">chevron_left</i></SupsisButton>
            <datetime
                v-model="filters.startDate"
                :max-datetime="maxDate"
                :min-datetime="minDate()"
                :placeholder="$t('message.startDate')"
                auto
                input-class="form-control rounded-0"
                type="datetime"
            />
            <datetime
                v-model="filters.endDate"
                :max-datetime="maxDate"
                :min-datetime="minDate()"
                :placeholder="$t('message.endDate')"
                auto
                input-class="form-control rounded-0"
                type="datetime"
            />
            <SupsisButton @click="nextDate" ghost small><i class="material-icons">chevron_right</i></SupsisButton>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import moment from "moment/moment";
import { mapActions, mapState } from "vuex";
import SupsisButton from "../../Pages/Settings/components/SupsisButton.vue";
import Avatar from "vue-avatar";

export default Vue.extend({
    name: "ReportFilterTool",
    components: { SupsisButton, Avatar },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            filters: _.cloneDeep(this.value),
            maxDate: moment().toISOString(),
            datetimeOpen: false,
        };
    },
    computed: {
        ...mapState({}),
    },
    methods: {
        ...mapActions({}),
        nextDate() {
            const diffDays = moment(this.filters.endDate).diff(moment(this.filters.startDate), "days");

            let period = diffDays < 6 ? "days" : diffDays < 28 ? "weeks" : diffDays < 360 ? "months" : "years";

            this.filters.startDate = moment(this.filters.startDate).add(1, period).toISOString();
            this.filters.endDate = moment(this.filters.endDate).add(1, period).toISOString();
        },
        prevDate() {
            const diffDays = moment(this.filters.endDate).diff(moment(this.filters.startDate), "days");

            let period = diffDays < 6 ? "days" : diffDays < 28 ? "weeks" : diffDays < 360 ? "months" : "years";

            this.filters.startDate = moment(this.filters.startDate).subtract(1, period).toISOString();
            this.filters.endDate = moment(this.filters.endDate).subtract(1, period).toISOString();
        },
        minDate() {
            return this.filters.startDate ? moment().subtract(45, "day").toISOString() : null;
        },
        syncDatetimeLayer(open) {
            this.datetimeOpen = open;
            if (this._contentViewEl) {
                this._contentViewEl.style.zIndex = open ? "10050" : "";
            }
        },
    },
    mounted() {
        this._contentViewEl = this.$el.closest ? this.$el.closest(".content-view") : null;
        var self = this;
        this._dtObserver = new MutationObserver(function () {
            var hasPopup = !!self.$el.querySelector(".vdatetime-popup");
            if (hasPopup !== self.datetimeOpen) {
                self.syncDatetimeLayer(hasPopup);
            }
        });
        var vdatetimeEls = self.$el.querySelectorAll(".vdatetime");
        for (var i = 0; i < vdatetimeEls.length; i++) {
            self._dtObserver.observe(vdatetimeEls[i], { childList: true, subtree: true });
        }
    },
    beforeDestroy() {
        if (this._dtObserver) this._dtObserver.disconnect();
        this.syncDatetimeLayer(false);
    },
    watch: {
        value: {
            handler: function (value) {
                const isEqual = _.isEqual(this.filters, value);
                if (!isEqual) this.filters = _.cloneDeep(value);
            },
            deep: true,
        },
        filters: {
            handler: function (value) {
                this.$emit("input", value);
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.report-filter-tool {
    display: flex;
    gap: 20px;
    width: 100%;

    &.report-filter-tool--datetime-open {
        position: relative;
        z-index: 10060 !important;
    }

    .date-filter {
        display: flex;
        gap: 10px;
        align-items: center;

        .vdatetime {
            width: 250px;
        }
    }
}
</style>
